module.exports = __webpack_public_path__ + "static/hero-internal-mobility-8545c073d1a577181b302d05bd9e1779.svg";